<template>
  <div>
    <template
      v-for="group in ['starters', 'bench']"
      v-if="match.teams.a.match[group]"
      >
      <div class="center-title center" :key="group"><h2 class="center">{{group|capitalise}}</h2></div>
      <section class="fullwidth">
        <div :class="[item[1]]" v-for="item in [
          ['a', 'part-first'],
          ['b', 'part-last'],]"
          :key="item.$index">
          <ul>
            <li v-for="playerKey in match.teams[item[0]].match[group]" :key="playerKey" v-if="match.players[playerKey]">
              <router-link
                      class="clean"
                      :to="{name:'kabaddiSeasonPlayer', params:{key:match.season.key, playerkey:playerKey}}">
                      {{match.players[playerKey].name}}</router-link>
            </li>
            <li v-else>
              {{playerKey}} MISSING
            </li>
          </ul>
        </div>
      </section>
    </template>
    <template>
      <div class="center-title center"><h2 class="center">All Players</h2></div>
      <section class="fullwidth">
        <div :class="[item[1]]" v-for="item in [
          ['a', 'part-first'],
          ['b', 'part-last'],]"
          :key="item.$index">
          <div
          v-for="role in match.teamPlayersByRole(item[0])"
          v-if="role.players.length"
          :key="role.name">
           <h5 class="top-space silent">{{role.name}}</h5>
            <ul>
              <li v-for="playerKey in role.players" :key="playerKey" v-if="playerKey">
                        <span class="clickable"
                          @click="onPlayerSelected(playerKey)">
                          {{match.players[playerKey].name}}
                        </span>
              </li>
              <li v-else>
                {{playerKey}} MISSING
              </li>
            </ul>
          </div>
        </div>
      </section>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    match: Object
  },
   methods: {
    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    }
  }
}
</script>
